import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import type {TwoLineOptionWithIcon} from 'shells/select-two-line-icon/select-two-line-icon';

import type {MeetingForReport} from './graphql/hooks/use-get-meetings-for-report';

export function getMeetingOption(meeting: MeetingForReport): TwoLineOptionWithIcon {
    const hostName = meeting.primaryHost?.name;
    const bookingCount = meeting.bookingsCountLast90Days;

    let sublabel: string | undefined;
    if (hostName && bookingCount > 0) {
        const bookingLabel = bookingCount === 1 ? 'booking' : 'bookings';
        sublabel = `${hostName} \u2022 ${bookingCount} ${bookingLabel}`;
    } else if (hostName) {
        sublabel = hostName;
    } else if (bookingCount > 0) {
        const bookingLabel = bookingCount === 1 ? 'booking' : 'bookings';
        sublabel = `${bookingCount} ${bookingLabel}`;
    }

    return {
        value: meeting.id,
        label: meeting.name,
        sublabel,
    };
}

export function getFiltersFromUrl(activeFilters: FilterObject[]): {
    meetingId: string | null;
} {
    const meetingFilter = safelyGetFilterByKey(activeFilters, 'meetingId');
    return {
        meetingId: meetingFilter ? String(meetingFilter) : null,
    };
}
